import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'button'];

  connect() {
    this.selectedOptions = new Set();
    this.syncFromDOM();
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.boundHandleOutsideClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleOutsideClick, true);
  }

  toggle() {
    this.dropdownTarget.classList.toggle('hidden');
    this.dropdownTarget.classList.toggle('opacity-0');
    this.dropdownTarget.classList.toggle('scale-95');
  }

  toggleOption(event) {
    const checkbox = event.target;
    const value = checkbox.dataset.value;

    if (checkbox.checked) {
      this.selectedOptions.add(value);
    } else {
      this.selectedOptions.delete(value);
    }

    this.updateButtonLabel();
    this.submitForm();
  }

  updateButtonLabel() {
    const values = Array.from(this.selectedOptions);
    const text = values.length > 0 ? values.join(', ') : this.buttonTarget.dataset.placeholder;
    this.buttonTarget.innerText = text;

    if (values.length > 0) {
      this.buttonTarget.classList.remove('text-black-400');
      this.buttonTarget.classList.add('text-black-1000');
    } else {
      this.buttonTarget.classList.remove('text-black-1000');
      this.buttonTarget.classList.add('text-black-400');
    }
  }

  syncFromDOM() {
    this.selectedOptions.clear();
    this.element.querySelectorAll('input[type=checkbox]:checked').forEach((cb) => {
      this.selectedOptions.add(cb.dataset.value);
    });
    this.updateButtonLabel();
  }

  submitForm() {
    const form = this.element.closest('form');
    if (form) {
      form.requestSubmit();
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden', 'opacity-0', 'scale-95');
    }
  }

  clearSelection() {
    const checkboxes = this.element.querySelectorAll('input[type=checkbox]');
    checkboxes.forEach((checkbox) => (checkbox.checked = false));

    this.selectedOptions.clear();
    this.buttonTarget.innerText = this.buttonTarget.dataset.placeholder;
    this.buttonTarget.classList.remove('text-black-1000');
    this.buttonTarget.classList.add('text-black-400');

    this.dropdownTarget.classList.add('hidden', 'opacity-0', 'scale-95');
    this.submitForm();
  }
}
